export interface AskMention {
  id: string;
  name: string;
  kind: "project" | "company" | "person";
  detail?: string;
}

/** Search the full inventory before ranking. Prefixes precede incidental matches. */
export function matchAskMentions(choices: AskMention[], query: string): AskMention[] {
  const text = query.trim().toLocaleLowerCase();
  const unique = [...new Map(choices.map(choice => [`${choice.kind}:${choice.id}`, choice])).values()];
  const score = (choice: AskMention) => {
    const name = choice.name.toLocaleLowerCase();
    return name === text ? 0 : name.startsWith(text) ? 1 : name.split(/\s+/).some(word => word.startsWith(text)) ? 2 : 3;
  };
  return unique.filter(choice => !text || `${choice.name} ${choice.detail ?? ""}`.toLocaleLowerCase().includes(text))
    .sort((a, b) => score(a) - score(b) || a.name.localeCompare(b.name) || a.id.localeCompare(b.id));
}
